const user = JSON.parse(localStorage.getItem("user"));

const getToken = () => {
  if (user) {
    if (user.token) {
      return user.token;
    } else {
      localStorage.removeItem("user");
      alert("Token is lost. Please login again!!");
      window.location.href = "/login";
    }
  } else {
    alert("Token is expired. Please login again!!");
    window.location.href = "/login";
  }
};
export default getToken;
